import { render, staticRenderFns } from "./OfficerManage.vue?vue&type=template&id=1a659114&"
import script from "./OfficerManage.vue?vue&type=script&lang=js&"
export * from "./OfficerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports